// Action Items
// =============================================================================
import {gridExport} from './all';
import {openCloseWindow} from '../global/kendoWindows'

const createActionItemsGrid = function () {
    let $actionItemGrid = $('#actionItemsGrid');

    if ($actionItemGrid.length) {
        let pid = $('#pid').val(),
            sectionId = $('#sectionId').val(),
            dateTime = new Date(),
            fileName = 'ActionItemExport_' + dateTime.getFullYear() + (dateTime.getMonth() + 1) + dateTime.getDate() + '.xlsx',
            isSummary = $actionItemGrid.attr('data-summary') === 'True',
            isUserOverview = $actionItemGrid.attr('data-user-overview') === 'True',
            catCol = {},
            statusOptions = [
                {
                    text: 'Active', value: 1
                }, {
                    text: 'Closed', value: 2
                }, {
                    text: 'On Hold', value: 3
                }
            ];

        let aiStatusSelector = function (container, options) {
            $('<input required name="' + options.field + '"/>')
                .appendTo(container)
                .kendoDropDownList({
                    autoBind: true, dataTextField: 'text', dataValueField: 'value', dataSource: {
                        type: 'json', data: statusOptions
                    }
                });
        };

        if (isSummary) {
            catCol = {
                field: 'sTextProper', title: 'Category', attributes: {class: 'sTextProper'}, hidden: false, width: 90
            };
        }

        $actionItemGrid.kendoGrid({
            /*mobile: "phone",*/
            resizable: true, columns: [
                {
                    field: 'aDueDate',
                    title: 'Due Date',
                    attributes: {class: 'aDueDate'},
                    template: function (dataItem) {
                        if (dataItem.aStatus === 2) {
                            return dataItem.aDueDate.toLocaleDateString('en-US');
                        }
                        var ouText;
                        if (dataItem.daysUntilDue < 0) {
                            ouText = '<div class="t-red">' + (-1 * dataItem.daysUntilDue) + ' days past due</div>';
                        } else {
                            ouText = '<div class="t-green">' + dataItem.daysUntilDue + ' days</div>';
                        }
                        return dataItem.aDueDate.toLocaleDateString('en-US') + ouText;
                    },
                    width: 100
                }, catCol, {
                    field: 'aText', title: 'Action Item', attributes: {class: 'aText'}, width: 225
                }, {
                    field: 'aResponsibleName', title: 'Responsible', attributes: {class: 'aRespName'}, width: 125
                }, {
                    field: 'aResponsibleJobTitle',
                    title: 'Responsible Job Title',
                    attributes: {class: 'aRespJobTitle'},
                    hidden: true,
                    width: 100
                }, {
                    field: 'aIDDate',
                    title: 'Date Identified',
                    attributes: {class: 'aIDDate'},
                    type: 'date',
                    format: '{0: M/d/yyyy}',
                    width: 90
                }, {
                    field: 'aStatus',
                    title: 'Status',
                    attributes: {class: 'aStatus'},
                    values: statusOptions,
                    editor: aiStatusSelector,
                    autoBind: true,
                    width: 90
                }, {
                    field: 'daysUntilDue',
                    title: 'Days Until Due',
                    attributes: {class: 'aDaysUntil'},
                    type: 'int',
                    hidden: true,
                    width: 70
                }, {
                    field: 'assignedBy',
                    title: 'Assigned By',
                    attributes: {class: 'aDaysUntil'},
                    type: 'string',
                    hidden: false,
                    width: 125
                }, {
                    field: 'assignedByJobTitle',
                    title: 'Assigned By Job Title',
                    attributes: {class: 'aDaysUntil'},
                    type: 'string',
                    hidden: true,
                    width: 100
                }, {
                    field: 'resolutionComments',
                    title: 'Resolution Comments',
                    attributes: {class: 'aDaysUntil'},
                    type: 'string',
                    hidden: false,
                    width: 100
                }, {
                    field: 'resolutionDate',
                    title: 'Resolution Date',
                    attributes: {class: 'aIDDate'},
                    type: 'date',
                    format: '{0: M/d/yyyy}',
                    width: 90
                }, {
                    field: 'resolvedBy',
                    title: 'Resolved By',
                    attributes: {class: 'aDaysUntil'},
                    type: 'string',
                    hidden: false,
                    width: 125
                }, {
                    field: 'aid', hidden: true, menu: false, attributes: {class: 'aid'}
                }
            ], dataSource: {
                autoSync: true, schema: {
                    model: {
                        id: 'aid', fields: {
                            aid: {editable: false},
                            sTextProper: {editable: false},
                            aDueDate: {editable: false, type: 'date'},
                            aText: {editable: false},
                            aResponsibleName: {editable: false},
                            aResponsibleJobTitle: {editable: false},
                            aIDDate: {editable: false, type: 'date'},
                            aStatus: {editable: true},
                            daysUntilDue: {editable: false, type: 'int'},
                            assignedBy: {editable: false, type: 'string'},
                            assignedByJobTitle: {editable: false, type: 'string'},
                            resolutionComments: {editable: false, type: 'string'},
                            resolutionDate: {editable: false, type: 'date'},
                            resolvedBy: {editable: false, type: 'string'}
                        }
                    }
                }, transport: {
                    create: {
                        url: '/Forms/ActionItem/Create', type: 'POST', dataType: 'json'
                    }, read: {
                        url: isSummary ? '/Forms/ActionItem/GetAll' : isUserOverview ? '/Forms/ActionItem/GetUserItems' : '/Forms/ActionItem/GetSection',
                        type: 'GET',
                        dataType: 'json'
                    }, update: {
                        url: '/Forms/ActionItem/Update', type: 'PUT', dataType: 'application/json; charset=utf-8'
                    }, parameterMap: function (data, type) {
                        let rs = {};
                        if (type === 'create') {
                            rs['pid'] = pid;
                            rs['sid'] = sectionId;
                            return kendo.stringify($.extend(rs, data));
                        }
                        if (type === 'read') {
                            rs['pid'] = pid || data.pid;
                            rs['sid'] = sectionId;
                            let $userId = $('#userId');
                            let userId = 0;
                            if($userId.length) userId = $userId.val();
                            rs['userId'] = userId;
                            return rs;
                        }
                        if (type === 'update') {
                            rs['pid'] = pid || data.pid;
                            rs['aid'] = data.aid;
                            rs['status'] = data.aStatus;
                            if (data.aStatus === 2) {
                                let resolutionWindow = $('#itemResolutionWindow');
                                resolutionWindow.data('kendoWindow').open();
                                resolutionWindow.attr('data-controls', JSON.stringify(rs));
                            }
                            return rs;
                        }
                    }
                }
            }, toolbar: kendo.template($('#template').html()), excel: {
                fileName: fileName, filterable: true
            }, dataBound: function (arg) {
                let k_grid = $('#actionItemsGrid').data('kendoGrid');
                let data = arg.sender.element.find('tbody tr');

                $.each(data, function (i, row) {
                    let days = k_grid.dataItem(row).daysUntilDue;
                    let status = k_grid.dataItem(row).aStatus;
                    if (days < 0 && status !== 2) {
                        $(row).children('td').wrapInner(() => '<span class="grid-cell--status --danger"></span>');
                    }
                });

                let dataPoints = k_grid.dataSource._data.length;
                if (dataPoints !== 0) {
                    $('.js-action-items-tag').text(`${dataPoints} Action Item${dataPoints === 1 ? '' : 's'}`);
                }
            }, mobile: true, scrollable: true, sortable: {
                mode: 'multiple'
            }, filterable: true, editable: true, columnMenu: true
        });

        $('#addNewBtn').kendoButton({
            icon: 'plus'
        });
        openCloseWindow();
        //Add Grid Export Functionality
        gridExport();
    }
};

const saveNewActionItem = function () {
    let $saveBtn = $('#saveActionItem');

    if ($saveBtn) {
        $saveBtn.click(function () {
            let $actionItemText = $('#aText'),
                $aResp = $('#aRespName'),
                $idDate = $('#aIDDate'),
                $dueDate = $('#aDueDate'),
                aText = $actionItemText.val(),
                aResp = $aResp.val(),
                idDate = $idDate.val(),
                dueDate = $dueDate.val(),
                pid = $('#pid').val(),
                sectionId = $('#sectionId').val();

            $actionItemText.removeClass('is-invalid');
            $aResp.removeClass('is-invalid');
            $idDate.removeClass('is-invalid');
            $dueDate.removeClass('is-invalid');

            if (aText !== '' && aResp !== '' && idDate !== '' && dueDate !== '') {
                let responsible = aResp, actionItem = {
                    pid: pid,
                    sid: parseInt(sectionId),
                    aText: aText,
                    responsible: parseInt(responsible),
                    status: 1,
                    idDate: idDate,
                    dueDate: dueDate
                }, dataSource = $('#actionItemsGrid').data().kendoGrid.dataSource;

                $.post('/Forms/ActionItem/Create', actionItem, function () {
                    // Close Window
                    $saveBtn.closest('.k-window-content').data('kendoWindow').close();
                    dataSource.read();

                    //Remove popup values
                    $dueDate.data('kendoDatePicker').value('');
                    $actionItemText.val('').keyup();
                    $aResp.data('kendoAutoComplete').value('');
                    $idDate.data('kendoDatePicker').value('');
                });
            } else {
                //add validation
                if (aText === '') $actionItemText.addClass('is-invalid');
                if (aResp === '') $aResp.addClass('is-invalid');
                if (idDate === '') $idDate.addClass('is-invalid');
                if (dueDate === '') $dueDate.addClass('is-invalid');

            }
        });
    }
};

const submitResolution = function () {
    let $submitBtn = $('#submitComments');

    if ($submitBtn.length) {
        $submitBtn.click(function () {
            let $resolutionWindow = $('#itemResolutionWindow'),
                data = JSON.parse($resolutionWindow.attr('data-controls')), $comments = $('#itemResolution');
            $resolutionWindow.data('kendoWindow').close();
            data.comments = $comments.val();
            $comments.val('');
            $.post('/Forms/ActionItem/SubmitResolution', data, function () {
                //refresh that grid with the new comments
                $('#actionItemsGrid').data('kendoGrid').dataSource.read();
            });
        });
    }
};

export default function () {
    createActionItemsGrid();
    saveNewActionItem();
    submitResolution();
}